import React, { useEffect, useState } from "react";
// import data from "../../json/landingpage/OurExpertService.json";
import { Link, useParams } from "react-router-dom";
import content from "../../json/landingpage/Headerlinkpagedata.json";

const OurExpertService = () => {
  const { category } = useParams();


  const [data, setData] = useState();

  useEffect(() => {
    setData(content[category]);
  });

  return (
   
    <>

      {data && (<div className="2xl:container py-20 pb-10  md:px-20 px-6">
        <div className="w-full flex justify-center">
          <h2 className="font-semibold text-24 md:text-36 lg:text-48 text-primarycolor text-center w-full   w-[90%] ">
            {data.title}
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-6 gap-4 pt-16">
          {data.array.map((item, i) => {
            const totalItems = data.array.length;
            const itemsPerRowMD = 2;
            const itemsPerRowLG = 3;

            const isLastRowMD = totalItems % itemsPerRowMD !== 0 && i >= totalItems - (totalItems % itemsPerRowMD);
            const isLastRowLG = totalItems % itemsPerRowLG !== 0 && i >= totalItems - (totalItems % itemsPerRowLG);

            // Default span for full row
            let spanClass = "md:col-span-2 lg:col-span-2";

            // If 2 items in last row
            if (isLastRowMD && totalItems % itemsPerRowMD === 2) {
              spanClass = "md:col-span-2"; // 2 items evenly split at md
            } else if (isLastRowMD && totalItems % itemsPerRowMD === 1) {
              spanClass = "md:col-span-4"; // full span at md
            }

            if (isLastRowLG && totalItems % itemsPerRowLG === 2) {
              spanClass += " lg:col-span-3"; // half at lg
            } else if (isLastRowLG && totalItems % itemsPerRowLG === 1) {
              spanClass += " lg:col-span-6"; // full span at lg
            }

            return (
              <div
                key={i}
                className={`p-6 rounded-[16px] bg-white border-[1px] border-journyborder shadow-services flex flex-col items-start justify-between  ${spanClass} ${category=="products"?"gap-3":"gap-4"}`}
              >
                <div className={`flex ${category=="products"?"flex-col items-start gap-10":"items-center  gap-3 "}`}>
                  <img src={process.env.PUBLIC_URL + item.icon} alt="icon" />
                  <h4 className="font-semibold text-18 sm:text-20 text-primarycolor">
                    {item.name}
                  </h4>
                </div>

                <p className="text-14 font-regular sm:text-16 text-secondaryblack">
                  {item.desc}
                </p>
                <Link
                  to={item.href}
                  className="flex items-center justify-center mt-4"
                >
                  <p className="text-ctaorange font-semibold">Get Started</p>
                  <div className="w-[34px] h-[34px] text-orange flex items-center justify-center">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/images/Herosection/greaterthan.svg"
                      }
                      alt="icon"
                    />
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      </div>)}
    </>
  );
};

export default OurExpertService;
